import React from 'react';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import styles from '../../prediction-header-bar/prediction-header-bar.scss';

interface OutputOnDayWeeklyProps {
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  value: string;
}

export const OutputOnDayWeekly = ({ disabled, onChange, value }: OutputOnDayWeeklyProps) => {
  const intl = useIntl();

  return (
    <div className={styles.formInput}>
      <Select
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        value={value}
        label={intl.formatMessage({ id: 'predict.output_on_day', defaultMessage: 'Output on day' })}
        size="large"
      >
        <Option text={intl.formatMessage({ id: 'common.monday', defaultMessage: 'Monday' })} value="1" />
        <Option text={intl.formatMessage({ id: 'common.tuesday', defaultMessage: 'Tuesday' })} value="2" />
        <Option text={intl.formatMessage({ id: 'common.wednesday', defaultMessage: 'Wednesday' })} value="3" />
        <Option text={intl.formatMessage({ id: 'common.thursday', defaultMessage: 'Thursday' })} value="4" />
        <Option text={intl.formatMessage({ id: 'common.friday', defaultMessage: 'Friday' })} value="5" />
        <Option text={intl.formatMessage({ id: 'common.saturday', defaultMessage: 'Saturday' })} value="6" />
        <Option text={intl.formatMessage({ id: 'common.sunday', defaultMessage: 'Sunday' })} value="7" />
      </Select>
    </div>
  );
};
